import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { DeviceModel } from '.';

export class DeviceResponse extends GlobalResponseObject{
    data?: DeviceModel[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: DeviceModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 